import type React from "react";
import { forwardRef } from "react";
import { cn } from "../../utils/cn";

export interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "strong" | "subtle";
  hover?: boolean;
}

const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, variant = "default", hover = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "backdrop-blur-xl bg-white/5 dark:bg-white/5 border border-white/10 shadow-2xl rounded-xl transition-all duration-300",
          {
            "backdrop-blur-2xl bg-white/8 border-white/15 shadow-[0_12px_40px_rgba(0,0,0,0.4)]":
              variant === "strong",
            "backdrop-blur-md bg-white/3 border-white/5": variant === "subtle",
            "hover:shadow-[0_20px_60px_rgba(0,0,0,0.3)] hover:-translate-y-1":
              hover,
          },
          className
        )}
        {...props}
      />
    );
  }
);
GlassCard.displayName = "GlassCard";

export { GlassCard };
